import React, { useEffect, useState } from 'react';

export const useFormValidation = (options) => {

    const [formValues, setValues] = useState(options?.initialValues || {});
    const [formErrors, setErrors] = useState({});
    const [details, setDetails] = useState({});
    const [formValid, setFormValid] = useState(options?.validations ? false : true);

    useEffect(() => {
        validateForm();
    }, [formErrors]);

    const handleInput = (event, sanitize) => {
        const name = event.target.name ? event.target.name : "";
        const val = event.target.value ? event.target.value : "";
        const value = sanitize ? sanitize(val) : val.trim();

        if (event.type == 'blur' && !details[name] && !details[name]?.touched) {
            setDetails({
                ...formValues,
                [name]: {touched: true},
            });
        }
        if (event.type === 'blur' || (formErrors[name] && formErrors[name].value) || (details[name] && details[name]?.touched)) {
            validateInput(name, value);
        } 
        
        setValues({
            ...formValues,
            [name]: value,
        });
    }

    const handleForm = (event) => {
        event.preventDefault();
        const validations = options?.validations;

        if (validations) {
            for (const key in validations) {
                const value = formValues[key];
                validateInput(key, value);
            }
        } else {
            setFormValid(true);
        }
    };

    const validateInput = (name, value) => {

        const validations = options?.validations;
        let error = {
            value: false,
            message: ""
        };

        if (validations) {
            const validation = validations[name];
            const required = validation?.required && validation?.required?.value === true;

            // REQUIRED  
            if (required && !value) {
                error = {
                    value: true,
                    message: validation?.required?.message
                };
            }

            // PATTERN  
            const pattern = value ? validation?.pattern : "";
            if (pattern && pattern?.value && !RegExp(pattern.value).test(value)) {
                error = {
                    value: true,
                    message: validation?.pattern?.message
                };
            }

            // CUSTOM  
            const custom = validation?.custom;
            if (custom && custom?.isValid && !custom.isValid(value)) {
                error = {
                    value: true,
                    message: validation?.custom?.message
                };
            }
        } 

        if (!formErrors[name] || (formErrors[name] && ((formErrors[name].value !== error.value) || (formErrors[name].message !== error.message)))) {
            setErrors({
                ...formErrors,
                [name]: error
            });
        }
    }

    const validateForm = () => {
        let isFormValid = true;
        const validations = options?.validations;

        if (validations) {
            if (Object.keys(formErrors).length > 0) {
                Object.keys(formErrors).forEach((key) => {
                    if (formErrors[key].value) {
                        isFormValid = false;
                    }
                })
            } else {
                isFormValid = false;
            }
        } 

        setFormValid(isFormValid);
    }

    return {
        formErrors,
        formValid,
        handleForm,
        handleInput,
        formValues
    }
}